import type {
  CreateDeviceLogSessionV2MutationRequestApi,
  EnumDeviceLogTypeApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { CreateLogRequestFormularySchema } from '../../../components/create-log-request-modal/hooks/useFormularyOfCreateLogRequest.hook';

const FROM_HOUR_TO_MINUTES = 60;
const FROM_MINUTE_TO_SECONDS = 60;
export function fromCreateLogRequestFormularySchemaToCreateDeviceLogSessionV2MutationRequestApi({
  title,
  description,
  collectFrom,
  durationHour,
}: CreateLogRequestFormularySchema): CreateDeviceLogSessionV2MutationRequestApi {
  return {
    requestedDuration: durationHour * FROM_HOUR_TO_MINUTES * FROM_MINUTE_TO_SECONDS,
    title,
    description,
    types: collectFrom?.map((el) => el.toUpperCase() as EnumDeviceLogTypeApi),
  };
}
